module.exports = __webpack_public_path__ + "static/media/  (82).3e865b7c.jpg";